<div class="sdl-bg">

  <!-- Marigold garland -->
  <div class="sdl-garland" aria-hidden="true"></div>

  <!-- Lanterns (wide screens) -->
  <div class="sdl-lantern sdl-lantern-left sdl-anim" aria-hidden="true">
    <div class="sdl-lantern-rope"></div>
    <img src="assets/images/spin/lantern.webp" alt="" loading="lazy" decoding="async" width="116" height="200">
  </div>
  <div class="sdl-lantern sdl-lantern-right sdl-anim" aria-hidden="true">
    <div class="sdl-lantern-rope"></div>
    <img src="assets/images/spin/lantern.webp" alt="" loading="lazy" decoding="async" width="116" height="200">
  </div>

  <!-- Hero -->
  <section class="sdl-hero">
    <div class="sdl-hero-stage">
      <img class="sdl-dancer sdl-dancer-l sdl-anim" src="assets/images/spin/dancer-girl.webp"
           alt="" aria-hidden="true" fetchpriority="high" decoding="async" width="370" height="370">
      <div class="sdl-logo-wrap">
        <div class="sdl-logo-glow" aria-hidden="true"></div>
        <div class="sdl-logo-rays sdl-anim" aria-hidden="true"></div>
        <img class="sdl-logo" src="assets/images/spin/navratri-logo.webp" alt="9 Ratri Mahashagun Offer"
             fetchpriority="high" decoding="async" width="470" height="414">
      </div>
      <img class="sdl-dancer sdl-dancer-r sdl-anim" src="assets/images/spin/dancer-boy.webp"
           alt="" aria-hidden="true" fetchpriority="high" decoding="async" width="370" height="370">
    </div>

    <p class="sdl-tagline">हर स्मार्टफोन पर घर ले जायें</p>
    <h1 class="sdl-headline">निश्चित उपहार!</h1>

    <div class="sdl-dates">
      <span class="sdl-dates-rule"></span>
      <span>11 – 20 October 2026</span>
      <span class="sdl-dates-rule sdl-dates-rule-r"></span>
    </div>

    <button type="button" class="sdl-cta sdl-anim" (click)="openLogin()">
      <span>{{ isLoggedIn ? 'Spin Now' : 'Login & Spin' }}</span>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"
           stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="sdl-cta-arrow">
        <path d="M5 12h14M13 6l6 6-6 6"></path>
      </svg>
    </button>

    <!-- Live winners ticker (shown only when real winners data is available) -->
    <div class="sdl-ticker" aria-live="off" *ngIf="winners.length > 0">
      <span class="sdl-ticker-badge">LIVE WINNERS</span>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
           stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="sdl-ticker-icon">
        <circle cx="12" cy="12" r="9"></circle>
        <path d="M12 7v5l3 2"></path>
      </svg>
      <div class="sdl-ticker-text">
        <strong>{{ winners[tickIndex].city }}</strong>
        <span>· {{ winners[tickIndex].phone }}</span>
        <span>ने जीता</span>
        <strong class="sdl-ticker-gift">{{ winners[tickIndex].gift }}</strong>
        <span class="sdl-ticker-time">{{ winners[tickIndex].minsAgo }} min ago</span>
      </div>
    </div>
  </section>

  <!-- Login modal -->
  <div class="sdl-modal-backdrop" *ngIf="loginOpen" (click)="closeLogin()">
    <div class="sdl-login" role="dialog" aria-labelledby="sdl-login-title" (click)="$event.stopPropagation()">
      <div class="sdl-login-head">
        <div class="sdl-login-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="#6B0A14" stroke-width="2.2"
               stroke-linecap="round" stroke-linejoin="round">
            <rect x="6" y="2" width="12" height="20" rx="2.5"></rect>
            <path d="M11 18h2"></path>
          </svg>
        </div>
        <div class="sdl-login-title-wrap">
          <h2 id="sdl-login-title" *ngIf="loginStage === 'phone'">Login करें</h2>
          <h2 id="sdl-login-title" *ngIf="loginStage === 'otp'">Verify OTP</h2>
          <h2 id="sdl-login-title" *ngIf="loginStage === 'code'">Spin code डालें</h2>
          <span *ngIf="loginStage === 'phone'">Purchase इसी number से check होगी</span>
          <span *ngIf="loginStage === 'otp'">OTP sent to +91 {{ maskedPhone }}</span>
          <span *ngIf="loginStage === 'code'">Invoice पर छपा हुआ कोड</span>
        </div>
        <button type="button" class="sdl-login-close" (click)="closeLogin()" aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round">
            <path d="M6 6l12 12M18 6L6 18"></path>
          </svg>
        </button>
      </div>

      <div class="sdl-login-body">
        <!-- Phone -->
        <div *ngIf="loginStage === 'phone'" class="sdl-login-stack">
          <label for="sdl-phone">Purchase के समय दिया mobile number</label>
          <div class="sdl-phone-field" [class.sdl-field-err]="phoneErr">
            <span class="sdl-phone-cc">+91</span>
            <input id="sdl-phone" type="tel" inputmode="numeric" autocomplete="tel-national"
                   [(ngModel)]="phone" (input)="phoneErr = false"
                   maxlength="10" placeholder="98765 43210">
          </div>
          <p class="sdl-err" *ngIf="phoneErr">Please enter a valid 10-digit mobile number</p>
          <button type="button" class="sdl-login-cta"
                  [disabled]="!phoneValid || busy"
                  (click)="sendOtp()">
            {{ busy ? 'Sending...' : 'Send OTP' }}
          </button>
          <button type="button" class="sdl-login-link" (click)="showCodeStage()">
            Invoice पर spin code है? यहाँ डालें
          </button>
        </div>

        <!-- OTP -->
        <div *ngIf="loginStage === 'otp'" class="sdl-login-stack">
          <label for="sdl-otp">5-digit OTP डालें</label>
          <input id="sdl-otp" type="text" inputmode="numeric" autocomplete="one-time-code"
                 [(ngModel)]="otp" maxlength="5" class="sdl-otp-input"
                 placeholder="• • • • •">
          <button type="button" class="sdl-login-cta"
                  [disabled]="!otpValid || busy"
                  (click)="verifyOtp()">
            {{ busy ? 'Verifying...' : 'Verify OTP' }}
          </button>
          <div class="sdl-login-row">
            <button type="button" class="sdl-login-link" (click)="changeNumber()">Change number</button>
            <button type="button" class="sdl-login-link sdl-login-link-muted"
                    [disabled]="resendSeconds > 0 || busy"
                    (click)="resendOtp()">
              {{ resendLabel }}
            </button>
          </div>
        </div>

        <!-- Invoice spin code -->
        <div *ngIf="loginStage === 'code'" class="sdl-login-stack">
          <label for="sdl-code">Spin code</label>
          <input id="sdl-code" type="text" [(ngModel)]="invoiceCode"
                 class="sdl-code-input" placeholder="Enter code" autocomplete="off">
          <button type="button" class="sdl-login-cta" (click)="submitInvoiceCode()">
            Continue
          </button>
          <button type="button" class="sdl-login-link" (click)="changeNumber()">
            Use mobile number instead
          </button>
        </div>

        <p class="sdl-login-foot">
          हर smartphone invoice पर 1 spin! Number सिर्फ़ purchase check करने के लिए है।
        </p>
      </div>
    </div>
  </div>

  <!-- Terms & Conditions -->
  <section class="sdl-terms">
    <h2 class="sdl-terms-title">Terms &amp; conditions</h2>
    <ul class="sdl-terms-list">
      <li>Offer valid 11–20 October 2026 on smartphone purchases at participating SmartDukaan stores.</li>
      <li>One spin per smartphone invoice, linked to the mobile number given at billing and verified by OTP.</li>
      <li>Gifts are handed over after the spin, against the Claim ID shown. Products shown are only suggestive and the actual product may vary.</li>
      <li>Gifts subject to stock availability. Only eligible smartphone models qualify. Offer is non-transferable and cannot be exchanged for cash.</li>
    </ul>
  </section>

  <!-- How it works -->
  <section class="sdl-how">
    <div class="sdl-how-title-row">
      <img class="sdl-diya sdl-anim" src="assets/images/spin/diya.webp" alt="" aria-hidden="true"
           loading="lazy" decoding="async" width="72" height="80">
      <h2 class="sdl-how-title">How it works</h2>
      <img class="sdl-diya sdl-anim sdl-diya-flip" src="assets/images/spin/diya.webp" alt="" aria-hidden="true"
           loading="lazy" decoding="async" width="72" height="80">
    </div>
    <p class="sdl-how-sub">Four simple steps to your Navratri gift</p>
    <div class="sdl-steps">
      <div class="sdl-step">
        <span class="sdl-step-n">1</span>
        <h3>Buy a smartphone</h3>
        <p>Visit any participating SmartDukaan store during the offer window.</p>
      </div>
      <div class="sdl-step">
        <span class="sdl-step-n">2</span>
        <h3>Get a scratch card</h3>
        <p>Every eligible purchase earns a spin on the Navratri wheel — guaranteed gift.</p>
      </div>
      <div class="sdl-step">
        <span class="sdl-step-n">3</span>
        <h3>Login with mobile</h3>
        <p>Enter the mobile number used at purchase. We verify it instantly.</p>
      </div>
      <div class="sdl-step">
        <span class="sdl-step-n">4</span>
        <h3>Spin to reveal</h3>
        <p>Tap the wheel to reveal your gift. One spin per card.</p>
      </div>
    </div>
  </section>
</div>
